export enum ROLE_COLUMN_NAME {
  ID = "id",
  NAME = "name",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
  DELETED = "deleted",
}

export enum ROLE_LABEL_NAME {
  ID = "ID",
  NAME = "Name",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
  DELETED = "Deleted",
}

export const ROLE_FILTER_COLUMN_OPTIONS = [
  {
    label: ROLE_LABEL_NAME.NAME,
    value: ROLE_COLUMN_NAME.NAME,
  },
];
